(function ($) {
  "use strict";

  $(document).ready(function () {
    if (typeof $.fn.fitVids === "function" ) {
        responsiveVideo();
    }
  });

  function responsiveVideo() {
    $("#main-page-area").fitVids();
  }
})(jQuery);
